export const OUIHELP_LEGAL_ENTITY_UUID = "6e61267c-ed52-40de-810d-4903ac0ac6c8";

// This is a "fake" UUID shared with the backend to mean "all presta entities"
export const JOYA_LEGAL_ENTITY_UUID = "9749b356-d462-4f75-ae7c-175c2577439a";
